import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import RegionService from '../services/RegionService';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 0,
    totalPages: 0,
  },
  error: null,
  loading: false,
  submitLoading: false,
};

export const regionList = createAsyncThunk(
  'region/list',
  async ({ perPage, page, keyword, isActive }) => {
    try {
      const resp = await RegionService.List({ perPage, page, keyword, isActive });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const regionAdd = createAsyncThunk('region/add', async (data) => {
  try {
    const resp = await RegionService.Create(data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const regionEdit = createAsyncThunk('region/edit', async ({ id, data }) => {
  try {
    const resp = await RegionService.Put(id, data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const regionDelt = createAsyncThunk('region/delt', async (id) => {
  try {
    const resp = await RegionService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const getAllRegions = createAsyncThunk('region/all', async () => {
  try {
    const resp = await RegionService.All();
    return resp;
  } catch (e) {
    return e.response;
  }
});

const regionSlice = createSlice({
  name: 'region',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(regionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(regionList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...(action.payload?.data?.data?.regions ?? [])];
          state.pagination = action.payload?.data?.data?.pagination ?? state.pagination;
        } else {
          state.error = action.payload?.data?.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(regionList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(regionAdd.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(regionAdd.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          const region = action.payload?.data?.data?.region;
          if (region) {
            state.datas.unshift(region);
          }
          toast.success(action.payload?.data?.message);
        } else {
          toast.error(action.payload?.data?.message);
        }
        state.formError = action.payload?.data?.errors;
        state.submitLoading = false;
      })
      .addCase(regionAdd.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(regionEdit.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(regionEdit.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          const region = action.payload?.data?.data?.region;
          if (region) {
            const index = state.datas.findIndex((item) => item.id === region.id);
            if (index !== -1) {
              state.datas[index] = { ...state.datas[index], ...region };
            }
          }
          toast.success(action.payload?.data?.message);
        } else {
          toast.error(action.payload?.data?.message);
        }
        state.formError = action.payload?.data?.errors;
        state.submitLoading = false;
      })
      .addCase(regionEdit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(regionDelt.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(regionDelt.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          const region = action.payload?.data?.data?.region;
          if (region) {
            const index = state.datas.findIndex(({ id }) => id === region.id);
            if (index !== -1) {
              state.datas[index] = { ...state.datas[index], ...region };
            }
          }
          toast.success(action.payload?.data?.message);
        }
        state.submitLoading = false;
      })
      .addCase(regionDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(getAllRegions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRegions.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          const payload = action.payload?.data?.data;
          state.datas = [...(Array.isArray(payload) ? payload : payload?.regions || [])];
        } else {
          state.error = action.payload?.data?.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(getAllRegions.rejected, (state, action) => {
        state.error = action.payload?.data?.message;
        state.loading = false;
        toast.error(state.error);
      });
  },
});

export const regionSelector = (state) => state?.region;

export default regionSlice.reducer;
